import { getDrawerContent as getDrawerContentShared } from 'pages/mobile/Finance/shared/drawers';
import React from 'react';

import { DrawerSection } from '../drawerSections';
import ApprovalsDrawer from './ApprovalsDrawer';
import FilesDrawer from './FilesDrawer';

export { ApprovalsDrawer, FilesDrawer };

const DRAWER_COMPONENTS: Record<DrawerSection, React.ComponentType> = {
  [DrawerSection.Files]: FilesDrawer,
  [DrawerSection.Approvals]: ApprovalsDrawer,
};

export const getDrawerContent = (
  section: DrawerSection | null,
): React.ReactNode => getDrawerContentShared(section, DRAWER_COMPONENTS);
